module.exports = __webpack_public_path__ + "media/src/assets/images/logo_octo_acn_white-eafc02a4548ef283fc56cd819c726481.png";